import { PU_TOAST_DEFAULT_CONFIG, ToastConfig } from '@pin-up-global/common';

export const TOAST_CONFIG: ToastConfig = {
  ...PU_TOAST_DEFAULT_CONFIG,
  closeIconName: 'pu-close',
}
